import { Injectable } from '@angular/core';
import { HttpHeaders, HttpResponse } from '@angular/common/http';

import { ServiceResponse } from "@common/data-models/service/service-response";
import { ExternalApiData } from "@common/data-models/service/external-api-data";
import { ExternalAction, ExternalActionResponse } from "@common/data-models/service/external-action";
import { ErrorTypes } from '@common/data-models/misc/errors';
import { Record } from '@common/data-models/records/record'

import { NomWebServicesJson } from "@common/services/nom-web-services-json";
import { ObjectTypes } from '../enums/object-types';

@Injectable({ providedIn: 'root' })
export class ExternalActionsService {
    public ExternalActions: Array<ExternalAction> = [];

    private externalActionsCache: { [id: string]: Array<ExternalAction> } = {};
    public getExternalActionsFor(rec: Record): Array<ExternalAction> {
        if (!rec?.type) return [];
        if (this.externalActionsCache[rec.type]) return this.externalActionsCache[rec.type];
        if (this.ExternalActions.length > 0) {
            switch (rec.type) {
                case ObjectTypes.TOPIC: {
                    let topicActions = this.ExternalActions.filter((item) => {
                        return item.TopicAction;
                    });
                    this.externalActionsCache[rec.type] = topicActions;
                    break;
                }
                case ObjectTypes.ASSIGNMENT: {
                    let assignmentActions = this.ExternalActions.filter((item) => {
                        if (rec.guid) {
                            return item.AssignmentAction;
                        } else {
                            return item.AssignmentAction && item.ID === 'DELETE';
                        }
                    });
                    this.externalActionsCache[rec.type] = assignmentActions;
                    break;
                }
                case ObjectTypes.PUBLICATION_CHANNEL:
                case ObjectTypes.PUBLICATIONLIST: {
                    let publicationChannel = this.ExternalActions.filter((item) => {
                        if (item.ID == 'DUPLICATE') return;
                        return item.PublicationListAction;
                    });
                    this.externalActionsCache[rec.type] = publicationChannel;
                }
            }
            return this.externalActionsCache[rec.type];
        } else {
            return [];
        }
    }

    public getExternalActionsForType(t: number): Array<ExternalAction> {
        if (!t) return [];
        if (this.externalActionsCache[t]) return this.externalActionsCache[t];
        if (this.ExternalActions.length > 0) {
            if (t == ObjectTypes.TOPIC) {
                let topicActions = this.ExternalActions.filter((item) => {
                    return item.TopicAction;
                });
                this.externalActionsCache[t] = topicActions;
            }
            if (t == ObjectTypes.ASSIGNMENT) {
                let assignmentActions = this.ExternalActions.filter((item) => {
                    return item.AssignmentAction;
                });
                this.externalActionsCache[t] = assignmentActions;
            }
            if (t == ObjectTypes.PUBLICATION_CHANNEL || t == ObjectTypes.PUBLICATIONLIST) {
                let publicationChannel = this.ExternalActions.filter((item) => {
                    if (item.ID == 'DUPLICATE') return
                    return item.PublicationListAction;
                });
                this.externalActionsCache[t] = publicationChannel;
            }
            return this.externalActionsCache[t];
        } else {
            return [];
        }
    }

    constructor(
        public nomWebServicesJson: NomWebServicesJson
    ) {
    }

    public async postExternalAction(data: ExternalApiData): Promise<ServiceResponse<ExternalActionResponse>> {
        let responseBody = new ExternalActionResponse();
        let responseBool = false;
        let res: HttpResponse<any> = null;
        try {
            res = await this.nomWebServicesJson.post(
                "/api/ExternalActions",
                data,
                {
                    headers: new HttpHeaders({
                        "Content-Type": "application/json",
                        "X-ENPS-TOKEN": this.nomWebServicesJson.NomTokenId
                    }),
                    responseType: 'json',
                    observe: 'response'
                });
            if (res.status >= 200 && res.status < 300) {
                responseBool = true;
            }
        } catch (e) {
            this.nomWebServicesJson.showErrorModal({
                message: "Fail to execute external action!",
                detailMessage: `Fail to execute external action! \n\rStackTrace: NomWebServicesJson.postExternalAction(); \n\rError: ${e}`
            }, ErrorTypes.ERROR);
        }
        try {
            if (res) {
                responseBody = <ExternalActionResponse>res.body;
            }
        } catch (err) { }
        return new ServiceResponse<any>(responseBool, responseBody);
    }
}
